import styled from "styled-components";

export const ImgArea = styled.div`
    position : ${props=>props.absolute === "absolute"? "absolute" : props.position};
    display : flex;
    bottom : 5px;
    left : 7px;
`


export const HeartArea = styled.div`
    display : flex;
    align-items : center;
    border : 1px solid #eee;
    border-radius : 50%;
    width : 34px;
    height : 34px;
    box-sizing : border-box;
    justify-content : center;
    cursor: pointer;
`
export const Number = styled.div`   
    color : #c8c4c2;
    display : ${props => props.left? "flex" :  props.right?"flex" : "none"};
    align-items :center;
    margin : 0 5px;
`